export enum PanelLayout {
  vertical = 'vertical',
  horizontal = 'horizontal',
  combined = 'combined',
  bAsRightCol = 'bAsRightCol',
}

export enum PanelVariant {
  fill = 'fill',
  line = 'line',
  outline = 'outline',
}

export enum PanelStacking {
  default = 'default',
  bFirst = 'bFirst',
}

export enum PanelStatus {
  none = 'none',
  new = 'new',
  error = 'error',
  draft = 'draft',
}
